import { createContext } from "react";

export const ContactContext = createContext();
export const PersonalDataContext = createContext();
export const ContactDataContext = createContext();
export const SocialDataContext = createContext();
export const EntitySelectorContext = createContext();
export const AsesorsContext = createContext();
export const AsesorSelectorContext = createContext();
